import {Component, OnInit, AfterViewChecked} from '@angular/core';
import { Router,
         NavigationExtras } from '@angular/router';
import { CustomAuthService } from './auth.service';
import { DataService } from './core/data.service';
import {environment} from '../environments/environment';
import {AlertService} from './alert.service';

@Component({
  template: `
      <section class="login-form">
          <div class="container-t">
              <div class="form-wrapper">
                  <form *ngIf="!prodBuild" #loginForm="ngForm" (ngSubmit)="onSubmit()" [hidden]="submitted" class="">
                      <div class="heading">
                          <h2>Login</h2>
                          <h5>Please log in to continue</h5>
                      </div>
                      <div class="">
<!--                          <label for="username">Email Address</label>-->
                          <label for="username"
                                 aria-haspopup="true"
                                 role="tooltip"
                                 class="tooltip tooltip-validation tooltip-md"
                                 [class.invalid]="usernameInput.invalid && (usernameInput.dirty || usernameInput.touched)">
                              <input type="text" id="username" placeholder="Enter email address"
                                     required
                                     name="username"
                                     [(ngModel)]="username"
                                     #usernameInput="ngModel">
                              <span class="tooltip-content">
                                  Email Address is Required.
                              </span>
                          </label>
                      </div>
                      <button class="btn btn-primary" type="submit" [disabled]="loginForm.form.invalid">Login</button>
                      <h4 style="text-align: center; font-weight: 400;">OR</h4>
                      <button class="btn btn-primary" type="button" (click)="register()">Register</button>
                  </form>
                      <button class="btn btn-primary" (click)="signInWithGoogle()" >Sign in with Google</button>
              </div>
          </div>
      </section>`
})
export class LoginComponent implements OnInit, AfterViewChecked {

    loggedIn = false;
    isAdmin = false;
    prodBuild = true;
    username: string;
    submitted: boolean;
    signinCalled = false;

    constructor(public authService: CustomAuthService,
                public router: Router,
                private dataService: DataService,
                private alertService: AlertService) {
        this.alertService.clear();
        authService.loggedInStream$.subscribe(
            val => {
                this.loggedIn = val;
            });
        authService.isAdminStream$.subscribe(
            val => {
                this.isAdmin = val;
            });

        console.log('Checking for saved credentials');
        const chkLoggedIn = localStorage.getItem('loggedIn');
        if (chkLoggedIn) {
            this.loggedIn = true;
        }
        this.username = localStorage.getItem('username');
        // if(this.username && this.password){
        //   this.onSubmit();
        // }
    }

    ngOnInit(): void {
        if (this.loggedIn) {
            this.navigateAccordingly();
        }
        if (!environment.production) {
            this.prodBuild = false;
        }
    }

    ngAfterViewChecked(): void {
        if (!this.signinCalled) {
            this.signinCalled = true;
            // this.signInWithGoogle();
        }
    }

    public navigateAccordingly() {
        if (this.isAdmin) {
            this.router.navigate(['admin']);
        } else {
            this.router.navigate(['customer/tiles']);
        }
    }

    onSubmit() {
        // Calling login with optional kennel ID, if user is on a kennel website rather than generic website then
        // pass that kennel ID as the context for all other operations.  For now always login as kennel 1 (HollyIsland)

        this.authService.loggedInStream$.subscribe(
            val => {
                if (val) {
                    // Get the redirect URL from our auth service
                    // If no redirect has been set, use the default
                    const redirect = this.authService.redirectUrl ?
                        this.authService.redirectUrl : this.authService.isAdmin.takeLast ? '/admin' : '/customer/tiles';

                    // Set our navigation extras object
                    // that passes on our global query params and fragment
                    const navigationExtras: NavigationExtras = {
                        preserveQueryParams: true,
                        preserveFragment: true
                    };

                    // Redirect the user
                    const bookingData = this.authService.getBookingData();
                    if (bookingData) {
                        // if (!this.isAdmin) {
                            this.router.navigate(['customer/booking/new']);
                            return;
                        // }
                    }
                    this.router.navigate([redirect], navigationExtras);
                }
            });
        this.authService.sendToRestApiMethodDevMode(this.username);
    }

    login() {
        this.authService.login().subscribe(() => {

            // Get the redirect URL from our auth service
            // If no redirect has been set, use the default
            const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/admin';

            // Set our navigation extras object
            // that passes on our global query params and fragment
            const navigationExtras: NavigationExtras = {
                preserveQueryParams: true,
                preserveFragment: true
            };

            // Redirect the user
            this.router.navigate([redirect], navigationExtras);

        });
    }

    register() {
        this.router.navigate(['/register']);

    }

    signInWithGoogle() {
        this.authService.loggedInStream$.subscribe(
            val => {
                if (val) {
                    console.log('Login Status Changed: ' + val);

                    // Get the redirect URL from our auth service
                    // If no redirect has been set, use the default
                    // let redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/admin';
                    const redirect = this.authService.redirectUrl ?
                        this.authService.redirectUrl : this.authService.isAdmin.getValue() ? '/admin' : '/customer/tiles';

                    // Set our navigation extras object
                    // that passes on our global query params and fragment
                    const navigationExtras: NavigationExtras = {
                        preserveQueryParams: true,
                        preserveFragment: true
                    };

                    // Redirect the user
                    this.router.navigate([redirect], navigationExtras);
                }
            });
        this.authService.signInWithGoogle();
    }

}
